import cx from 'classnames';
import {
    BAZAAR_PLUS_PRICE_WITH_VAT_price,
    CHECK_YOUR_PLAN_STATE,
    CHECK_YOUR_PLAN_STATE__PLAN,
    CLOSE_WINDOW,
    FILLOUT_BILLING_INFO_FIRST,
    GET_PLUS_ALREADY_HAS,
    GET_PLUS_PAY_BY_BANK,
    GET_PLUS_PAY_BY_CARD,
    GET_PLUS_PAY_BY_SMS,
    GET_PLUS_PRICING_FOOTNOTE,
    GET_PRO_ALREADY_HAS,
    PLUS_PAYMENT_AMOUNT,
    PLUS_PAYMENT_BANK_ACCOUNT,
    PLUS_PAYMENT_BANK_ACCOUNT_NUMBER,
    PLUS_PAYMENT_CUSTOMER_DATA,
    PLUS_PAYMENT_WILL_BE_PROCESSED_IN_2_3_DAYS,
    PLUS_SEND_PAYMENT_TO_OUR_ACCOUNT,
    VENDOR_DOWNLOAD_PAYMENT_PDF,
} from 'mk/autogenerated/translations/PriceList.393dd7f273601e4516aa41257fda678a'
import Icon from 'mk/bazaar/common/components/Icon';
import assetUrl from 'mk/common/assetUrl';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import {
    bo_proforma_invoice_file_for_user_url,
    plan_invoices_url,
} from 'mk/urls/functions';
import { PriceListItem } from 'mk2/apps/plan/schemas';
import { cardPaymentUrl, planPlanForUrl, smsPaymentUrl } from 'mk2/apps/plan/urls';
import { loginUrl } from 'mk2/apps/users/urls';
import { Btn,  BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { Img } from 'mk2/components/Img';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import { Modal } from 'mk2/components/Modal';
import { Panel } from 'mk2/components/Panel';
import { url } from 'mk2/helpers/urls';
import { UserEntity } from 'mk2/schemas';
import React, { useState } from 'react';
import styles from './PriceList.mscss';

interface OwnProps {
    allowPayments: boolean;
    bazaarPlusId: number;
    bazaarProId: number;
    paymentVS: string;
    priceListOf: 'plus' | 'pro';
    prices: PriceListItem[];
    requestUser: UserEntity;

    onStoreEvent(name: string, props: any);
}

type Props = OwnProps;

export const PriceList = React.memo<Props>(({
    allowPayments, bazaarPlusId, bazaarProId, onStoreEvent, paymentVS, priceListOf, prices, requestUser,
}) => {
        const [getShowModalPayByBankWithPrice, setShowModalPayByBankWithPrice] = useState<PriceListItem>(null);
        const onShowModalPayByBankWithPrice = (priceListItem: PriceListItem) => () => {
            setShowModalPayByBankWithPrice(priceListItem);
            onStoreEvent('bzplus_payment_start', { method: 'bank', period: priceListItem.itemPeriodConst });
        };
        const onHideModalPayByBankWithPrice = () => {
            setShowModalPayByBankWithPrice(null);
        };

        if (!prices) {
            return null;
        }

        const paymentUrl = (type, qs) => {
            return type === 'sms'
                ? url(smsPaymentUrl, {}, qs)
                : type === 'card'
                    ? url(cardPaymentUrl, {}, qs)
                    : type === 'bank'
                        ? null // no url for paying by bank, modal is displayed
                        : null;
        };

        const paymentLabel = {
            sms: GET_PLUS_PAY_BY_SMS,
            card: GET_PLUS_PAY_BY_CARD,
            bank: GET_PLUS_PAY_BY_BANK,
        };

        const hasRecurringItem = prices.findIndex((item) => !!item.itemIsRecurring) >= 0;

        return (
            <div
                id="pricing"
                className={styles.PriceList}
            >
                <div className={styles.PriceList__items}>
                    {prices.map((item, idx) => {

                        const paymentUrlKeys = priceListOf === 'plus' ? {
                            bazaar: bazaarPlusId,
                            period: item.itemPeriodConst,
                        } : {
                            vendor: bazaarProId,
                            period: item.itemPeriodConst,
                        };

                        if (!item.itemButton1 && !item.itemButton2) {
                            return null;
                        }

                        return (
                            <div
                                key={idx}
                                className={cx(
                                    styles.PriceList__items__item,
                                    item.itemBestItem && styles['PriceList__items__item--best'],
                                    idx === 0 && !item.itemBestItem && styles['PriceList__items__item--firstButNotBest'],
                                    ACTIVE_SERVER_ID === 202 && styles['PriceList__items__item--202'],
                                    item.itemBestItem && ACTIVE_SERVER_ID === 202 && styles['PriceList__items__item--best202'],
                                )}
                            >
                                <div className={styles.PriceList__items__item__header}>{item.itemHeader + (item.itemIsRecurring ? '*' : '')}</div>
                                <div className={styles.PriceList__items__item__price}>{item.itemPrice}</div>
                                <div className={styles.PriceList__items__item__period}>{item.itemPeriod}</div>
                                <div className={styles.PriceList__items__item__save}>{item.itemDiscount}</div>
                                <div className={styles.PriceList__items__item__pay}>
                                    {(priceListOf === 'plus' && !bazaarPlusId) || (priceListOf === 'pro' && !bazaarProId) ? (
                                        <>
                                            {item.itemButton1 && (
                                                <Btn
                                                    type={BtnType.Blue}
                                                    label={paymentLabel[item.itemButton1]}
                                                    link={
                                                        // spat na tuto istu url, aby uvidel ceny platne presne pre neho
                                                        // (urobi nas <Link/> automaticky ak ideme na loginUrl)
                                                        loginUrl
                                                    }
                                                    sidePadding={BtnSidePadding.LeftRight}
                                                    className={styles.PriceList__items__item__btn}
                                                />
                                            )}
                                            {item.itemButton2 && (
                                                <Btn
                                                    type={BtnType.Link}
                                                    label={paymentLabel[item.itemButton2]}
                                                    link={
                                                        // spat na tuto istu url, aby uvidel ceny platne presne pre neho
                                                        // (urobi nas <Link/> automaticky ak ideme na loginUrl)
                                                        loginUrl
                                                    }
                                                    sidePadding={BtnSidePadding.LeftRight}
                                                    className={styles.PriceList__items__item__btn2}
                                                />
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {allowPayments ? (
                                                <>
                                                    {item.itemButton1 && (
                                                        <Btn
                                                            type={BtnType.Blue}
                                                            label={paymentLabel[item.itemButton1]}
                                                            link={item.itemButton1 !== 'bank' && paymentUrl(item.itemButton1, paymentUrlKeys)}
                                                            onClick={item.itemButton1 === 'bank' && onShowModalPayByBankWithPrice(item)}
                                                            sidePadding={BtnSidePadding.LeftRight}
                                                            className={styles.PriceList__items__item__btn}
                                                        />
                                                    )}
                                                    {item.itemButton2 && (
                                                        <Btn
                                                            type={BtnType.Link}
                                                            label={paymentLabel[item.itemButton2]}
                                                            link={item.itemButton2 !== 'bank' && paymentUrl(item.itemButton2, paymentUrlKeys)}
                                                            onClick={item.itemButton2 === 'bank' && onShowModalPayByBankWithPrice(item)}
                                                            sidePadding={BtnSidePadding.LeftRight}
                                                            className={styles.PriceList__items__item__btn2}
                                                        />
                                                    )}
                                                    {(item.itemButton1 === 'bank' || item.itemButton2 === 'bank') && (
                                                        <Modal show={!!getShowModalPayByBankWithPrice} onHide={onHideModalPayByBankWithPrice} className={styles.PriceList__payByBankModal}>
                                                            <div className={styles.PriceList__payByBankModal__container}>
                                                                <a data-google-interstitial="false" className={styles.PriceList__payByBankModal__close} onClick={onHideModalPayByBankWithPrice}>
                                                                    <Icon icon="action-file-delete-gray" />
                                                                </a>
                                                                {!!getShowModalPayByBankWithPrice && (
                                                                    <Panel className={styles.PriceList__payByBankModal__panel}>
                                                                        <h2>{PLUS_SEND_PAYMENT_TO_OUR_ACCOUNT}</h2>
                                                                        <table className={styles.PriceList__payByBankModal__paymentDetails}>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <th>{PLUS_PAYMENT_BANK_ACCOUNT}</th>
                                                                                    <td><strong>{PLUS_PAYMENT_BANK_ACCOUNT_NUMBER}</strong></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th>{PLUS_PAYMENT_CUSTOMER_DATA}</th>
                                                                                    <td><strong>{paymentVS}</strong></td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th>{PLUS_PAYMENT_AMOUNT}</th>
                                                                                    <td className={styles.PriceList__payByBankModal__priceWithVat}>
                                                                                        <Interpolate
                                                                                            i18nKey={BAZAAR_PLUS_PRICE_WITH_VAT_price}
                                                                                            price={<strong>{getShowModalPayByBankWithPrice.itemPrice}</strong>}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                                {priceListOf === 'pro' && (
                                                                                    <tr>
                                                                                        <th />
                                                                                        <td>
                                                                                            <Link to={bo_proforma_invoice_file_for_user_url({product: 'pro', id: bazaarProId, period: getShowModalPayByBankWithPrice.itemPeriodConst})}>
                                                                                                {VENDOR_DOWNLOAD_PAYMENT_PDF}
                                                                                            </Link>
                                                                                            <br/>
                                                                                            <Link to={plan_invoices_url(requestUser.username, {billing: true})}>
                                                                                                {FILLOUT_BILLING_INFO_FIRST}
                                                                                            </Link>
                                                                                        </td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>

                                                                        <div className={styles.PriceList__payByBankModal__processing}>
                                                                            {PLUS_PAYMENT_WILL_BE_PROCESSED_IN_2_3_DAYS}
                                                                        </div>

                                                                        <div className={styles.PriceList__payByBankModal__closeBtn}>
                                                                            <Btn
                                                                                label={CLOSE_WINDOW}
                                                                                onClick={onHideModalPayByBankWithPrice}
                                                                            />
                                                                        </div>
                                                                    </Panel>
                                                                )}
                                                            </div>
                                                        </Modal>
                                                    )}
                                                </>
                                            ) : (
                                                <div>
                                                    {priceListOf === 'plus' ? GET_PLUS_ALREADY_HAS : GET_PRO_ALREADY_HAS}
                                                    <Link
                                                        to={url(planPlanForUrl, { username: requestUser.username }, { src: 'my_account' })}
                                                    >
                                                        {CHECK_YOUR_PLAN_STATE}
                                                    </Link>
                                                    {CHECK_YOUR_PLAN_STATE__PLAN}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
                {(hasRecurringItem || ACTIVE_SERVER_ID === 201) && (
                    <div className={styles.PriceList__pricingFootnote}>
                        {hasRecurringItem && (
                            '*' + GET_PLUS_PRICING_FOOTNOTE
                        )}
                        {ACTIVE_SERVER_ID === 201 && (
                            <>
                                <br/>
                                <Img
                                    src={assetUrl + `img/bo/operators-v2.png`}
                                    width={85}
                                    height={20}
                                />
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    },
);
